import { msg, str } from '@lit/localize';
import { validateURLDirect }  from './formsUtilities';
const accessProvisions = [
    {name:"AccessibleBabyFacilities",label:msg(`Accessible Baby Facilities`)},
    {name:"AccessibleParking",label:msg(`Accessible Parking`)},
    {name:"AccessibleToilets",label:msg(`Accessible Toilets`)},
    {name:"AdaptedInformation",label:msg(`Adapted Information`)},
    {name:"AssistanceAnimals",label:msg(`Assistance Animals`)},
    {name:"AudioDescription",label:msg(`Audio Description`)},
    {name:"Captioning",label:msg(`Captioned`)},
    {name:"ChangingPlacesToilet",label:msg(`Changing Places Toilet`)},
    {name:"ChilledPerformance",label:msg(`Chilled Performance`)},
    {name:"DementiaFriendly",label:msg(`Dementia Friendly`)},
    {name:"HearingLoopsAndHeadsets",label:msg(`Hearing Loops and Headsets`)},
    {name:"MinimalWalkingDistances",label:msg(`Minimal Walking Distances`)},
    //{name:"NoContentWarnings",label:msg(`No Content Warnings`)},
    {name:"NoStrobeLightingHazeEffects",label:msg(`No Strobe Lighting / Haze Effects`)},
    {name:"QuietSpaces",label:msg(`Quiet Spaces`)},
    {name:"RelaxedPerformance",label:msg(`Relaxed Performance`)},
    {name:"SeatAccess",label:msg(`Seat Access`)},
    {name:"SensoryAdapted",label:msg(`Sensory Adapted`)},
    {name:"SignLanguage",label:msg(`Sign Language`)},
    {name:"StepFreeLevelAccess",label:msg(`Step Free Level Access`)},
    {name:"WheelchairAccessible",label:msg(`Wheelchair Accessible`)}, 
];

const eventTypes = [
    {name:"ArtAndExhibitions",label:msg(`Art and Exhibitions`)},
    {name:"Cabaret",label:msg(`Cabaret`)},
    {name:"Circus",label:msg(`Circus`)},
    {name:"Comedy",label:msg(`Comedy`)},
    {name:"CoursesAndWorkshops",label:msg(`Courses and Workshops`)},
    {name:"Craft",label:msg(`Craft`)},
    {name:"Dance",label:msg(`Dance`)},
    {name:"FamiliarisationTours",label:msg(`Familiarisation Tours`)},
    {name:"FamilyFriendly",label:msg(`Family Friendly`)},
    {name:"FilmCinema",label:msg(`Film / Cinema`)},
    {name:"Festival",label:msg(`Festival`)},
    {name:"ImmersiveAndVR",label:msg(`Immersive and VR`)},
    {name:"LiteratureAndPoetry",label:msg(`Literature and Poetry`)},
    {name:"Music",label:msg(`Music`)},
    {name:"Musical",label:msg(`Musical`)},
    {name:"Opera",label:msg(`Opera`)},
    {name:"Pantomime",label:msg(`Pantomime`)},
    {name:"TalksAndDebates",label:msg(`Talks and Debates`)},
    {name:"Theatre",label:msg(`Theatre`)},
    {name:"TouchTours",label:msg(`Touch Tours`)}
];

const languages = [
    {name: 'en', label: 'English'},
    {name: 'cy', label: 'Cymraeg'},
   // {name: 'ga', label: 'Gaeilge'},
    {name: 'gd', label: 'Gaelic'}
]

const processEventData = (_eventData,locations=[],allProvisions=[]) => {
    let returnEventData;
    let eventData = _eventData?.hasOwnProperty('event_data') ? _eventData.event_data : _eventData;
    let instances = [];
    if(eventData?.hasOwnProperty('instances')){
        instances = eventData.instances.map(instance => {
            let date = instance.start ? new Date(instance.start) : null;
            let endDate = instance.end ? new Date(instance.end) : null;

            // BEGINNING of new conditional to allow ceratin start date and end date scenarios

            const now = new Date(); // take back by seven days
            now.setDate(now.getDate() - 7);
            now.setHours(0, 0, 0, 0); // strip time

            const dateInPast = date ? new Date(date).setHours(0,0,0,0) < now : false;
            const endDateInPast = endDate ? new Date(endDate).setHours(0,0,0,0) < now : false;
            let allowOldDates = false;
            if(endDateInPast||(!endDate&&dateInPast)){
                return {}; //deal with empy object when rendered in allin-repeater
            }
            if(dateInPast){
                allowOldDates = true;
            }

            // END of new conditional to allow ceratin start date and end date scenarios

            //---------------Prevent event instance start and end times from converting multiple times and adding more hours upon edit ------------------
            //let start_time = date ? date.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let start_time = instance.start ? instance.start.split('T')[1]?.substring(0,5) : '';
            //let end_time = endDate ? endDate.toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit' }) : '';
            let end_time = instance.end ? instance.end.split('T')[1]?.substring(0,5) : '';

            let start = date ? date.toISOString().split('T')[0] : '';
            let end = endDate ? endDate.toISOString().split('T')[0] : '';
            let bookingLink = instance.bookingLink ? instance.bookingLink : '';
            if(bookingLink){
                bookingLink = validateURLDirect(bookingLink);
            }
            return{
                start: start,
                start_time: start_time,
                end: end,
                end_time: end_time,
                bookingLink: bookingLink,
                zoneId: instance.zone ? instance.zone.id : '',
                instance_id: instance.id,
                provisions: instance.provisions,
                allowOldDates: allowOldDates,
            }
        });
    }
    let formatValue =eventData?.format;
    // if(!formatValue){
    //     formatValue = 'InPerson'
    // }
    let isTouring = eventData?.location?.id&&!locations.find(location => location.id === eventData?.location?.id);
    let locationIDValue = isTouring ? 'touring_location' : eventData?.location?.id;
    let touringLocationValue = isTouring ? eventData?.location?.id : null;
    if(!formatValue && !isTouring){
        formatValue = 'InPerson'
    }
    if(isTouring && formatValue==="InPerson"){
        formatValue = 'Touring';
    }
    let locURL = eventData?.locationUrl ? validateURLDirect(eventData.locationUrl) : '';
    let eventURL = eventData?.eventUrl ? validateURLDirect(eventData.eventUrl) : '';
    returnEventData = [
            {name:'name',type:'text',title:msg(str`What is the name of your event?`),value:eventData?.name,'required':true, description:msg(str``), error_message:msg(str`Please enter the name of your event`)},
            {name:'language',type:'select',title:msg(str`What language will you be submitting this event in?`),value:eventData?.language || 'en',options:languages, description:msg(str`You can create multiple events in different languages which will appear on the translated listings pages.`), error_message:msg(str`Please select the primary language of your event`)},
            {name:'locationId',type:'select',title:msg(str`Which location is this event held at?`),value:locationIDValue,'required':true,options:locations?.map(location => ({label: location.name, value: location.id})), description:msg(str`Tell audiences where this event will be held by choosing from the locations you have created.`), error_message:msg(str`Please select your event location`)},
            {name:'locationUrl',type:'url',title:msg(str`Please add a link to the access information page for your event`),value:locURL, description:msg(str`A link to relevant access information`)},
            {name:'locationName',type:'text',title:msg(str`Please add a name for your touring location`),value:eventData?.locationName, description:msg(str`A name for your touring location`)},
            {name: 'touringLocation', type: 'locationsearch', title: msg(str`Touring location`), value: touringLocationValue, requiredif: 'touring_location' },
            {name:'type',type:'multiselect',title:msg(str`What type of event is this?`),value:eventData?.type,'required':true,options:eventTypes, error_message:msg(str`Please select the closest option from the list of event types`)},
            {name: 'format', type:'select', title:msg(str`What is the format of your event?`),value:formatValue,options: [
                {value:'InPerson', label:'In Person'}, 
                {value:'Online', label:'Online'},          
                {value:'Hybrid', label:'Hybrid'},
                {value:'Touring', label:'On Tour'},
            ], description:msg(str`Choose an option to indicate whether this event is held in-person, online, or if it is a hybrid event which can be experienced online or in-person.`)},
            {name:'photo1',type:'file',title:msg('Location'),value:eventData?.photo1},
            {name:'photo2',type:'file',title:msg('Location'),value:eventData?.photo2},
            {name:'photo3',type:'file',title:msg('Location'),value:eventData?.photo3},
            {name: 'multiloader',type:'multiloader', description:msg(str`You can upload images to appear on your event listing.`)},
            {name:'description',type:'textarea',title:msg(str`Please add a short description about this event.`),value:eventData?.description,'required':true, description:msg(str`This should be a short overview of less than 500 characters.`), error_message:msg(str`Please add an event description`)},
            {name:'priceRangeLow', type: 'number', title: msg(str`Price range: low`), value: eventData?.priceRangeLow, min: 0.01, step: 1, description:msg(str`Please input the lowest ticket price for this event, to give customers an indication of the price range.`)},
            {name:'priceRangeHigh', type: 'number', title: msg(str`Price range: high`), value: eventData?.priceRangeHigh, min: 0.01, step: 1, description:msg(str`Please input the highest ticket price for this event, to give customers an indication of the price range.`)},
            {name:'defaultBookingLink',type:'url',title:msg(str`Please add the general booking link`),value:eventURL, description:msg(str`Enter the web address for your general booking page so that audiences can find out more and buy tickets for your event.`)},
            {name:'instances', type:'repeater', title: msg(str`Event instances`), value: instances, subFields: [
                {name:'start',type:'date',title:msg(str`Start date`),value:'',required:true, error_message:msg(str`Please add a start date`)},
                {name:'start_time',type:'time',title:msg(str`Start time`),value:'',required:true, error_message:msg(str`Please add a start time`)},
                {name:'end',type:'date',title:msg(str`End date`),value:'',required:false,showif:'start'},
                {name:'end_time',type:'time',title:msg(str`End time`),value:'',showif:'start',requiredif:'end'},
                {name:'bookingLink',type:'url',title:msg(str`Booking link`),value:'', description:msg(str`Enter the web address for your booking page for your event so that audiences can find out more and buy tickets.`)},
                {name:'zoneId',type:'select',title:msg(str`Which zone is this held at?`),value:'', description:msg(str`Tell audiences where this event will be held by choosing the zone.`), error_message:msg(str`Please select a zone`)},
                {name:'provisions',type:'provisions',title:msg(str`What access provisions are available on this instance of the event?`),provisions:allProvisions},
                {name:'instance_id',type:'hidden',title:'',value:''}
            ], description:msg(str`Here, you will input information such as date and time of your event and available access provisions. If this event takes place on multiple times/dates, you can add these instances individually.`)},
            {name:'status','type':'select','title':msg(str`Status`),'value':eventData?.status || 'Draft','required':true,'options':[{label:msg(str`Draft`),value:'Draft'},{label:msg(str`Published`),value:'Published'}], description:msg(str`If you are ready to publish your event so that audiences can find out more, change the status from draft to published and press submit.`)},
        ];
    return returnEventData;
}

const processProvisionData = (provisionData) => {
    provisionData = Object.entries(provisionData);
    provisionData = provisionData?.map((provision)=>{
        provision = provision[1];
        provision.provisions = provision.provisions.map((item)=>{
            if(item.hasOwnProperty('provision_data')){
                return {
                    name:item.standard?.name,
                    id:item.standard?.id,
                    image:item.provision_data.photo?.publicUrl,
                    alt:item.provision_data.photo?.altText,
                    description:item.provision_data?.description,
                    draft:item.provision_data?.draft,
                }
            }
            else{
                return {
                    name:item.name,
                    id:item.id,
                    image:item.image,
                    alt:item.alt,
                    description:item.description,
                    draft:item.draft,
                }
            }
        })
        return provision;
    }); 
    return provisionData;
}

const formatDateString = (date, longFormat = false, includeTime = true) => {
    if (!date) return '';
    let dateObj = new Date(date);
    const months = ['January', 'February', 'March', 'April', 'May', 'June','July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    if(longFormat){
        let year = '';
        let minutes = '';
        let hours = dateObj.getUTCHours();
        let ampm = 'am';
        if(hours >=12){
            ampm = 'pm';
        }
        hours = hours % 12;
        hours = hours ? hours : 12;

        if(new Date().getUTCFullYear() !== dateObj.getUTCFullYear()){
            year = ` ${dateObj.getUTCFullYear()}`;
        }
        let timestr = '';
        if(includeTime){
            if(dateObj.getUTCMinutes()!==0){
                minutes = `:${dateObj.getUTCMinutes().toString().padStart(2,'0')}`;
            }
            timestr = hours+minutes+ampm;
        }

        return [`${days[dateObj.getUTCDay()]}, ${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]}${year}`, timestr];
    }

    if(!includeTime){
        return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}`;
    }
    return `${dateObj.getUTCDate()} ${months[dateObj.getUTCMonth()]} ${dateObj.getUTCFullYear()}, ${dateObj.getUTCHours().toString()}:${dateObj.getUTCMinutes().toString().padStart(2,'0')}`;

};


const dateToMaybeRange = (open, close, longFormat = true) => {
    //console.log({open, close, longFormat});
    const parseDate = (dateStr) => {
        return new Date(dateStr);
    };

    // Helper function to format date according to the specified format
    const formatDate = (date, format) => {
        const options = {
            weekday: format.includes('D') ? 'short' : undefined,
            day: format.includes('j') ? 'numeric' : (format.includes('d') ? '2-digit' : undefined),
            month: format.includes('F') ? 'long' : (format.includes('m') ? '2-digit' : undefined),
            year: format.includes('Y') ? 'numeric' : undefined
        };

        // Remove undefined properties
        Object.keys(options).forEach(key => options[key] === undefined && delete options[key]);

        if (format === 'd') {
            return date.getUTCDate().toString().padStart(2, '0');
        }
        if (format === 'd/m') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}`;
        }
        if (format === 'm/Y') {
            return `${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'Y') {
            return date.getUTCFullYear().toString();
        }
        if (format === 'm') {
            return (date.getUTCMonth() + 1).toString().padStart(2, '0');
        }
        if (format === 'd/m/Y') {
            return `${date.getUTCDate().toString().padStart(2, '0')}/${(date.getUTCMonth() + 1).toString().padStart(2, '0')}/${date.getUTCFullYear()}`;
        }
        if (format === 'j') {
            return `${date.getUTCDate()}`;
        }
        if (format === 'j F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
        }
        if (format === 'F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
            return `${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }
        if (format === 'F') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
            return months[date.getUTCMonth()];
        }
        if (format === 'j F Y') {
            const months = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date.getUTCDate()} ${months[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
        }

        return date.toLocaleDateString();
    };

    // Define format strings based on longFormat parameter
    let day, dayMonth, monthYear, year, month, dayMonthYear;
    
    if (longFormat) {
        day = "j";
        dayMonth = "j F";
        monthYear = "F Y";
        year = "Y";
        month = "F";
        dayMonthYear = "j F Y";
    } else {
        day = "d";
        dayMonth = "d/m";
        monthYear = "m/Y";
        year = "Y";
        month = "m";
        dayMonthYear = "d/m/Y";
    }

    // If no close date or dates are the same, return single date
    let closeNoTime = close ? close.split('T')[0] : null;
    let openNoTime = open ? open.split('T')[0] : null;
    if (!close || openNoTime === closeNoTime) {
        return formatDate(parseDate(open), dayMonthYear);
    }

    const openDate = parseDate(open);
    const closeDate = parseDate(close);
    
    const eventStartMonth = openDate.getMonth();
    const eventEndMonth = closeDate.getMonth();
    const eventStartYear = openDate.getFullYear();
    const eventEndYear = closeDate.getFullYear();

    // Same month and year - show day range
    if (eventStartMonth === eventEndMonth && eventStartYear === eventEndYear) {
        return formatDate(openDate, day) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Same year - show month range
    else if (eventStartYear === eventEndYear) {
        return formatDate(openDate, dayMonth) + " - " + formatDate(closeDate, dayMonthYear);
    }
    // Different years - show full date range
    else {
        return formatDate(openDate, dayMonthYear) + " - " + formatDate(closeDate, dayMonthYear);
    }
};

const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger'
});

export { eventTypes, processEventData, processProvisionData, formatDateString, dateToMaybeRange, currencyFormatter };